import { createFileRoute } from '@tanstack/react-router'

import CreateKepPage from '@/components/pages/backoffice/_klb-petani/_kep/create/containers/CreateKepPage'

export const Route = createFileRoute('/_backoffice/klb-petani/kep/create/')({
  component: CreateKepPage
})
